module.exports = __webpack_public_path__ + "static/media/logo-iah.ddb82b1c.png";